import { initializeCommandingViewModeInternal } from '../mutators/initializeCommandingViewModeInternal';
import { onViewModeInitialized } from '../actions/onViewModeInitialized';
import { once } from 'owa-lodash';
import { isSingleLineRibbon } from '../selectors/isSingleLineRibbon';
import { registerAllLightIcons } from 'owa-command-ribbon-light-icon-font';
import { initializeKeytipsEnabledStatus } from './initializeKeytipsEnabledStatus';
import { registerKeytipsDataCollector } from './registerKeytipsDataCollector';

export const initializeCommandingViewMode: (primeBootSettingsOptions: any[]) => void = once(
    function initializeCommandingViewMode(primeBootSettingsOptions: any[]): void {
        initializeCommandingViewModeInternal(primeBootSettingsOptions);
        registerAllLightIcons(!isSingleLineRibbon());
        onViewModeInitialized();
        initializeKeytipsEnabledStatus();
        registerKeytipsDataCollector();
    }
);
